module.exports = __webpack_public_path__ + "img/slide05.cde71850.jpg";